((module) => {
    module.component('correctionAboutFactsBatchEdit', {
        template: require('./correctionAboutFactsBatchEditComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        },
        controller: [function(this: $TSFixMe) {
            const $ctrl = this;

            $ctrl.$onInit = function () {
                
                $ctrl.inputData = _.chunk($ctrl.resolve.inputData, 3);
                $ctrl.withName = $ctrl.resolve.withName;
                $ctrl.correctionBatchEditData = {};
            };

            $ctrl.displayErrorOnField = (field: $TSFixMe) => {
                return $ctrl.attempted && field.$touched && field.$invalid;
            }

            $ctrl.ok = function () {
                $ctrl.attempted = true;
                if ($ctrl.correctionBatchEditForm['desc'].$valid && (!$ctrl.withName || $ctrl.correctionBatchEditForm['name'].$valid)) {
                    $ctrl.close({ $value: $ctrl.correctionBatchEditData });
                } else {
                    if ($ctrl.withName)
                        $ctrl.correctionBatchEditForm['name'].$setTouched();
                    $ctrl.correctionBatchEditForm['desc'].$setTouched();
                }
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }]
    });

})(angular.module('topline.modules'));